import * as tslib_1 from "tslib";
var PaginationParams = /** @class */ (function () {
    function PaginationParams() {
        this.page = 1;
        this.pageSize = 100;
    }
    return PaginationParams;
}());
export { PaginationParams };
var QueryParams = /** @class */ (function (_super) {
    tslib_1.__extends(QueryParams, _super);
    function QueryParams() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueryParams;
}(PaginationParams));
export { QueryParams };
